import React, { useState } from "react";
import { useAuth } from "@/shared/hooks";
import { changeProfile } from "@/features/auth/api";
import '@/css/App.css';

const ChangeProfileModal = ({
    setting,
    showChangeProfileSettingsModal,
    registeredEmail,
    registeredPlatform,
    registeredPlatformUsername,
    refetchUser
  }: {
    setting: string;
    showChangeProfileSettingsModal: (value: string | null) => void;
    registeredEmail: string;
    registeredPlatform: string;
    registeredPlatformUsername: string;
    refetchUser: () => void;
  }) => {
    const [newInputValue, setNewInputValue] = useState("");
    const [dropdownValue, setDropdownValue] = useState("");
    const [profileChangeLoading, setProfileChangeLoading] = useState(false);
    const [updatePayKey, showUpdatePayKey] = useState(false);
    const [newSetting, setNewSetting] = useState("");
    const [error, setError] = useState<string | null>(null);
    const { firebaseUser, loading } = useAuth();
    const ChangeProfile = async () => {  
      if (loading || !firebaseUser) {
        return
      }

      try {
        const idToken = await firebaseUser.getIdToken();

        const result = await changeProfile({
          settingType: updatePayKey ? newSetting : setting,
          value: dropdownValue === "" ? newInputValue : dropdownValue,
          idToken: idToken,
        });
        if (!result.success) {
        setError(result.error || "profile change failed");


        return;
        }
      
        if (dropdownValue != ""){
            showUpdatePayKey(true);
            return
        }

        showUpdatePayKey(false);
        setDropdownValue("");
        setNewInputValue("");
        setNewSetting("");
        refetchUser();
      } catch (error) {
        console.error("error changing profile", error);
      }
      };

    return(
        <div>
                  <div className="popup fadeout">
                    <div className="popup closeLayer"></div>
                    { !updatePayKey &&
                    <div className="profileChangeContainer">
                      <div style={{ display: 'flex',justifyContent: 'space-between'}}>
                          <h3 style={{ display: 'flex', gap: '4px', color: 'rgba(236,240,241, 1)' }}>Current {setting != "platformUsername" ? setting : `Platform Username for ${registeredPlatform}`}: 
                            <div style={{ fontSize: '12px', color: 'rgba(236, 240, 241, 0.7)', display: 'flex', alignItems: 'center' }}>
                                {setting === "Email" ? registeredEmail : setting === "Platform" ? registeredPlatform : registeredPlatformUsername}
                            </div>
                        </h3>
                        
                      </div>
                      <div className="changeToContainer">
                      <div style={{ whiteSpace: 'nowrap' }}>Change to:</div>
                      {(setting === "Email" || setting === "platformUsername") ?
                      <div style={{ width: 'calc(100% - 12px)'}}>
                        <input
                          type={setting === "Email" ? "email" : "text"}
                          placeholder={setting === "Email" ? "Email" : "Username"}
                          className="changeToInput"
                          onChange={(e) => setNewInputValue(e.target.value)}
                          />
                          <div style={{ color: 'red', display: 'flex', marginTop: '10px', justifyContent: 'center', fontSize: '12px' }}>
                            {error}
                          </div>
                        </div>
                    
                        :
                        <div style={{ width: '100%', display: 'flex'}}>
                          <select
                            className="inputField changing"
                            value={dropdownValue}
                            style={{ height: '34px' }}
                            onChange={(e) => setDropdownValue(e.target.value)}
                          >
                            <option value="">Select a platform</option>
                            <option value="Paypal">Paypal</option>
                            <option value="Cashapp">Cashapp</option>
                            <option value="Venmo">Venmo</option>
                          </select>
                        <div style={{ color: 'red', display: 'flex', marginTop: '10px', justifyContent: 'center', fontSize: '12px' }}>
                            {error}
                        </div>
                        </div>
                      }
                      </div>
                      <div className="confirmationButtonsContainer" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button data-cy="cancel-confirmation-btn" onClick={() => {showChangeProfileSettingsModal(null)}}
                      className="cancelButton"
                    >
                      No, cancel
                    </button>
                    <button
                      data-cy="change-confirmation-btn"
                      className="progressButton"
                      style={{ width: '66.5px'}}
                      onClick={async () => {
                        setProfileChangeLoading(true);

                        try {
                        // Wait 1 second
                        await new Promise((resolve) => setTimeout(resolve, 1000));

                        await ChangeProfile();
                        } finally {
                        setProfileChangeLoading(false);
                        }
                      }}
                    >
                    {profileChangeLoading ? (
                        <div className="loader-dots">
                        <div></div>
                        <div></div>
                        <div></div>
                        </div>
                    ) : (
                        <div>
                            Yes, change
                        </div>
                      
                    )}
                    </button>
                  </div>
                </div>
                }
                    {updatePayKey && 
                    <div className="payKeyModal">
                        <div>Update your P2P username because of change of Processor</div>
                        <div style={{ color: 'rgba(236, 240, 241, 0.7)', fontSize: '12px' }}>Ignoring this could cause sending earned funds to wrong user.</div>

                        <div style={{ marginTop: '20px' }}>Current: {registeredPlatformUsername}</div>
                        <div className="changeToContainerPaykey">Change to: 
                        <input
                          type={"text"}
                          placeholder={"Username"}
                          className="changeToInput"
                          onChange={(e) => {
                            setNewInputValue(e.target.value);
                            setDropdownValue("");
                            setNewSetting("platformUsername");
                        
                          }}
                          />
                        </div>
                        <div style={{ color: 'red', display: 'flex', marginTop: '10px', justifyContent: 'center', fontSize: '12px' }}>
                            {error}
                        </div>
                        <div className="confirmationButtonsContainer" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                            data-cy="cancel-confirmation-btn"
                            onClick={() => {
                            showChangeProfileSettingsModal(null);
                            showUpdatePayKey(false);
                            setDropdownValue("");
                            setNewInputValue("");
                            setNewSetting("");
                        }}
                        className="cancelButton"
                        >
                        No, later
                        </button>

                        <button
                        data-cy="change-confirmation-btn"
                        className="progressButton"
                        style={{ width: '66.5px'}}
                        onClick={async () => {
                            setProfileChangeLoading(true);
                            
                            try {
                                await new Promise((resolve) => setTimeout(resolve, 1000));
                          
                                await ChangeProfile();
                              } finally {
                                setProfileChangeLoading(false);
                              }
                        }}
                        >
                        {profileChangeLoading ? (
                            <div className="loader-dots">
                            <div></div>
                            <div></div>
                            <div></div>
                            </div>
                        ) : (
                            <div>
                                Yes, change
                            </div>
                        
                        )}
                        </button>
                        </div>
                        
                    </div>
                    }
                  </div>
                  
                </div>
    )
}

export default ChangeProfileModal;